import { render, staticRenderFns } from "./dialog-notice.vue?vue&type=template&id=643ca549&"
import script from "./dialog-notice.vue?vue&type=script&lang=js&"
export * from "./dialog-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports